import io from 'socket.io-client';
import { getConfig } from "src/config/axios";

let axiosconf = getConfig();

let socket;

/*
const defaultOptions = {
    baseURL: axiosconf.veu.baseUrl,
    headers: axiosconf.veu.headers,
    timeout: axiosconf.timeout
};
*/

export const initiateSocket = (room) => {
    console.log("baseurl: ", axiosconf.veu.baseUrl)
    socket = io(axiosconf.veu.sockets);
    console.log(`Connecting socket...`);
    if (socket && room) socket.emit('join', room);
}

export const disconnectSocket = () => {
    console.log('Disconnecting socket...');
    if (socket) socket.disconnect();
}

export const subscribeToBackend = (cb) => {
    if (!socket) return (true);

    socket.on('chat', msg => {
        console.log('Websocket reply received!');
        return cb(null, { 'chat': msg });
    });

    socket.on('socken', msg => {
        console.log('Socket new value!');
        return cb(null, { 'socken': msg });
    });

}

export const sendMessage = (room, message) => {
    if (socket) socket.emit('chat', { message, room });
}
